import PrintFulfillment from './fulfillment';

const routes = [
  {
    path: '/print/fulfillment/:id',
    component: PrintFulfillment,
    action: ['read_only', 'manage'],
    service: ['nvo.wms.fulfillment'],
  },
];

export default routes;
